import { ElementRef, Injectable, Renderer2 } from '@angular/core';
import * as Cesium from 'cesium';
import { ConfigurationManagerService } from './configuration-manager.service';
import { Viewer } from 'cesium';
import { has, includes, isNil, isNull, merge, omit } from 'lodash';
import * as configData from '../../../../public/assets/config/default.json'
import { CoresService } from './cores.service';
import { PluginService } from './plugin.service';
import { DataContextService } from './data-context.service';
import { ArcAngelService } from './arc-angel.service';

@Injectable({
  providedIn: 'root'
})
export class CesiumService {
  private viewer: any;
  imageryProviderViewModels: any[] = [];
  providers: any[] = [];
  private cesiumViewer: any;
  config: any = configData;
  selectedImageryProviderViewModel: any = 0;
  OverLappingEntitiesService: any;
  rootScope: any;
  WindowService: any;
  GlobeService: any;
  scope!: {};

  constructor(
    private cores: CoresService,
    private pluginService: PluginService,
    private dataContext: DataContextService,
    private arcAngelService: ArcAngelService
  ) { }

  public plotPoints(el: ElementRef, renderer: Renderer2): Viewer | null {


    // Cesium.Ion.defaultAccessToken = "pk.eyJ1IjoicGF0cm9jaW5pdW0iLCJhIjoiY2pka2hvdHBwMDBzZjJ3bndnYzNudWc4byJ9.ha6b30pQ6YO53xF3BxuNAw"
    Cesium.Ion.defaultAccessToken = ConfigurationManagerService.settings.CesiumToken;

    // set default bing key if it exists
    // if(isNull(this.config.default ) && has(this.config.default, 'bing.key')){
    //   Cesium.BingMapsApi.defaultKey = this.config.default.bing.key;
    // }
    // set selected imagery model
    if (!isNil(this.config.cesium) && has(this.config.cesium, 'selectedImageryProviderViewModel')) {
      this.selectedImageryProviderViewModel = this.config.cesium.selectedImageryProviderViewModel;
    }

    if (configData.cesium.imageryProviderViewModels != null) {
      configData.cesium.imageryProviderViewModels.forEach(imageryProviderViewModel => {


        if ((imageryProviderViewModel.iconUrl != null)) {
          imageryProviderViewModel.iconUrl = Cesium.buildModuleUrl(imageryProviderViewModel.iconUrl);
        }
        imageryProviderViewModel.providers.forEach((provider) => {
          // init
          var imageryProvider;

          if (provider.instantiate) {
            imageryProvider = new (Cesium as any)[provider.call](provider.options);
          } else {
            imageryProvider = (Cesium as any)[provider.call](provider.options);
          }

          // push
          this.providers.push(imageryProvider);
        });
        // build model
        this.imageryProviderViewModels.push(new Cesium.ProviderViewModel(merge(omit(imageryProviderViewModel, ['providers']),
          {
            creationFunction: () => this.providers

          })));


      });
    }

    this.cesiumViewer = new Viewer(el.nativeElement, {
      animation: false,
      timeline: false,
      fullscreenButton: false,
      homeButton: false,
      infoBox: false,
      sceneModePicker: false,
      navigationHelpButton: false,
      scene3DOnly: false,
      shadows: false,
      terrainProviderViewModels: [],
      imageryProviderViewModels: this.imageryProviderViewModels,
      selectedImageryProviderViewModel: this.imageryProviderViewModels[this.selectedImageryProviderViewModel],
      contextOptions: {
        webgl: {
          failIfMajorPerformanceCaveat: false
        }
      },
      requestRenderMode: true,
      selectionIndicator: false
    });
   // this.cesiumViewer.extend(viewerCesiumNavigationMixin, {});

    // set up globe click handles
    var handler = new Cesium.ScreenSpaceEventHandler(this.cesiumViewer.scene.canvas);
    handler.setInputAction((event: any) => {
      var scene = this.cesiumViewer.scene;
      var pickedObjects = scene.drillPick(event.position, 200);
      this.OverLappingEntitiesService.hideOverlappingEntities();
      if (pickedObjects !== undefined && pickedObjects.length > 0 && this.rootScope.showvisualization) {
        var modifiedObjects = modifyObjects(pickedObjects);
        if (modifiedObjects.length === 1) {
          var pickedObject = modifiedObjects[0];
          if (pickedObject.type === 'ALERT') {
            this.rootScope.$broadcast('ARCANGEL_ALERT_SELECTED', pickedObject);
            this.rootScope.$broadcast('ALERT_READ', pickedObject);
          } else {
            openMapEntityDetailsWindow(pickedObject);
          }
        } else if (modifiedObjects.length > 1) {
          this.OverLappingEntitiesService.showOverlappingEntities(modifiedObjects, event.position);
        }
      }
      else {
        var position = this.cesiumViewer.camera.pickEllipsoid(event.position);
        var didHitGlobe = Cesium.defined(position);

        var lat: number;
        var lon: number;
        var height: number;

        if (didHitGlobe) {
          var cartographicPosition = Cesium.Ellipsoid.WGS84.cartesianToCartographic(position);
          lon = Cesium.Math.toDegrees(cartographicPosition.longitude);
          lat = Cesium.Math.toDegrees(cartographicPosition.latitude);
          Cesium.sampleTerrain(this.cesiumViewer?.terrainProvider, 9, [cartographicPosition]).then(() => { // eslint-disable-line
            height = cartographicPosition.height; // TODO:  Do we need to sample terrain everytime?
            return;
          })
        }
      }





    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    const openMapEntityDetailsWindow = (mapentity: any) => {
      if (mapentity && !this.WindowService.isEntityDetailsWindowOpen(mapentity.getWindowId())) {
        this.GlobeService.handleClick(this.scope, mapentity);
      }
    }
    // set up scene transition listeners
    this.cesiumViewer.scene.morphStart.addEventListener((e: any, prevMode: any, newMode: any) => {

      this.cores.fireMorphStartListeners(prevMode, newMode);
    });

    this.cesiumViewer.scene.morphComplete.addEventListener((e: any, prevMode: any, newMode: any) => {

      this.cores.fireMorphCompleteListeners(prevMode, newMode);
    });

    this.cores.setViewer(this.cesiumViewer);
    // on tick stuff
    this.cesiumViewer.clock.onTick.addEventListener((clock: any, currentTime: any) => {
      this.cores.fireOnTickEventHandlers(clock, currentTime);
    });
    this.cesiumViewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);

    this.pluginService.initialize();

    function modifyObjects(objects: any) {
      var newList = [];

      for (var objectKey in objects) {
        var arcLiveMapEntity = getArcLiveMapEntity(objects[objectKey]);
        if (arcLiveMapEntity && arcLiveMapEntity.showInOverlappingEntitiesUI()) {
          newList.push(arcLiveMapEntity);
        }
        if (objects[objectKey].id && objects[objectKey].id.type === 'alertCluster') {
          objects[objectKey].id.members.forEach((m: any) => {
            newList.push(m.alertEntity);
          });
        }
      }
      return newList;
    }

    function getArcLiveMapEntity(object: any) {
      if (object.id !== undefined && object.id.arcLiveMapEntity !== undefined) {
        return object.id.arcLiveMapEntity;
      } else if (object.primitive !== undefined && object.primitive.arcLiveMapEntity !== undefined) {
        return object.primitive.arcLiveMapEntity;
      }
    }

    this.dataContext.initialize();
    //add arcinsight, home,,signout, and settings buttons
    this.arcAngelService.getArcliveActions().then((/* actions */) => {
      var toolbar = ('.cesium-viewer-toolbar')[0];
      let content = `
        <app-inner-home class='cesium-button cesium-toolbar-button'></app-inner-home>
        <settings class='cesium-button cesium-toolbar-button'></settings>
        <signout class='cesium-button cesium-toolbar-button'></signout>
      `;
      
    // (toolbar).append(compile(content)(scope));
      return;
    }).catch(()=>{
     // $log.error(error);
    });


    this.cesiumViewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(-75.59777, 40.03883),
      point: {
        color: Cesium.Color.RED,
        pixelSize: 16,
      },
    });
    this.cesiumViewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(-80.5, 35.14),
      point: {
        color: Cesium.Color.BLUE,
        pixelSize: 16,
      },
    });
    this.cesiumViewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(-80.12, 25.46),
      point: {
        color: Cesium.Color.YELLOW,
        pixelSize: 16,
      },
    });
    return this.cesiumViewer;
  }
  getViewer(): Viewer {
    return this.cores.getViewer();
  }
}




